import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconReturn(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M21 8v4a1 1 0 0 1-1 1H5.914l2.793 2.793a1 1 0 1 1-1.414 1.414L2.086 12l5.207-5.207a1 1 0 0 1 1.414 1.414L5.914 11H19V8a1 1 0 1 1 2 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
